import React from 'react';
import { Box } from '@mui/material';
import { Alert, AlertTitle } from '@mui/lab';

export default function ConfigError({ errorType }) {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
      }}
    >
      <Alert
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
        variant="outlined"
        severity="error"
      >
        <AlertTitle>{errorType.config ? 'Site can not load' : 'Something went wrong'}</AlertTitle>
        {errorType.config
          ? 'No site exists for that URL - please check what you typed!'
          : 'Please try again later!'}
      </Alert>
    </Box>
  );
}
